import usePostData from '../../../../../hooks/postHook';

export const useUpdateUserEmail = ({ brandId, clientId }) => {
  const [{ body, isLoading, isError, error }, doUpdateUserEmail] = usePostData(
    `admin_brand/${brandId}/client/${clientId}/email`
  );

  return { body, isLoading, isError, error, doUpdateUserEmail };
};
